<template>
  <div class="w-100 position-relative" :class="height_size">
    <div v-if="data.image_list.length < 2" class="w-100 position-relative bg-dark-transparent" :class="height_size">
      <template v-if="data.image_list.length == 0">
        <img :src="data.image_url" class="position-relative z-index-1045"
          style="object-fit:contain !important; height:100%;width:100%;">
        <div class="position-absolute w-100 z-index-1042 bg-blur-overlay" :class="height_size"
          :style="{ backgroundImage: `url('${data.image_url}')` }"></div>
      </template>
      <template v-else>
        <img :src="data.image_list[0].image_url" class="position-relative z-index-1045"
          style="object-fit:contain !important; height:100%;width:100%;">
        <div class="position-absolute w-100 z-index-1042 bg-blur-overlay" :class="height_size"
          :style="{ backgroundImage: `url('${data.image_list[0].image_url}')` }"></div>
      </template>
    </div>
    <template v-else>
      <flickity ref="slider_detail" class="room-detail text-center" :options="$basic_slider_option">
        <div class="carousel-cell w-100" v-for="data_image in data.image_list">
          <div class="w-100 position-relative bg-dark-transparent" :class="height_size">
            <img :src="data_image.image_url" class="position-relative z-index-1045"
              style="object-fit:contain !important; height:100%;width:100%;">
            <div class="position-absolute w-100 z-index-1042 bg-blur-overlay" :class="height_size"
              :style="{ backgroundImage: `url('${data_image.image_url}')` }"></div>
          </div>
        </div>
      </flickity>
      <div class="concierge-slider-btn right" style="z-index: 1045 !important;" @click="clickButtonSlider('slider_detail','next')">
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
          <path
            d="M20 16.5202C20 16.3324 19.9249 16.1446 19.7821 16.0169L13.8253 10.2028C13.6976 10.0751 13.5324 10 13.3446 10C12.954 10 12.6535 10.293 12.6535 10.6836C12.6535 10.8714 12.7286 11.0441 12.8488 11.1719L18.7305 16.9258V16.1221L12.8488 21.8761C12.7286 21.9962 12.6535 22.169 12.6535 22.3643C12.6535 22.7549 12.954 23.0479 13.3446 23.0479C13.5324 23.0479 13.6976 22.9728 13.8329 22.8451L19.7821 17.031C19.9249 16.8883 20 16.7155 20 16.5202Z"
            fill="black" fill-opacity="0.85" />
        </svg>
      </div>
      <div class="concierge-slider-btn left" style="z-index: 1045 !important;" @click="clickButtonSlider('slider_detail','previous')">
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16.5" cy="16.5" r="16" fill="white" stroke="#D9D9D9" />
          <path
            d="M12.6535 16.5277C12.6535 16.7155 12.7286 16.9033 12.8714 17.031L18.8282 22.8451C18.9559 22.9728 19.1211 23.0479 19.3089 23.0479C19.6995 23.0479 20 22.7549 20 22.3643C20 22.1765 19.9249 22.0038 19.8047 21.876L13.923 16.1221V16.9258L19.8047 11.1718C19.9249 11.0516 20 10.8789 20 10.6836C20 10.293 19.6995 10 19.3089 10C19.1211 10 18.9559 10.0751 18.8207 10.2028L12.8714 16.0169C12.7286 16.1596 12.6535 16.3324 12.6535 16.5277Z"
            fill="black" fill-opacity="0.85" />
        </svg>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: ['data', 'height_size'],
    methods:{
      clickButtonSlider(refname, type) {
        if (type == 'next') this.$refs[refname].next()
        else this.$refs[refname].previous()
      },
    }
  }

</script>
<style>
  .bg-dark-transparent {
    background-color: rgb(35 35 35 / 88%)
  }

  .bg-blur-overlay {
    filter: blur(10px);
    top: 0px;
    left: 0px;
    opacity: 0.5;
    background-size: cover;
    background-position: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/activity/ProductSliderDetail.vue